module.exports = __webpack_public_path__ + "static/media/skipping-rope.d10888b6.svg";